<template>
  <div>
    <div class="d-flex">
      <v-icon
        class="mr-4 align-self-start"
        color="success"
        size="60"
      >
        mdi-check-circle
      </v-icon>
      <div>
        <h3>
          {{ $t('email-verification.verification-verified.body-texts.0') }}<br />
          {{ $t('email-verification.verification-verified.body-texts.1') }}
        </h3>
        <div>{{ $t('email-verification.verification-verified.body-texts.2') }}</div>
      </div>
      <v-spacer />
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <!-- TODO: check unsuported prop: fab -->
          <v-btn
            variant="text"
            size="small"
            :loading="loading"
            :disabled="loading"
            v-bind="props"
            @click="acknowledgeDefaultSender"
          >
            <v-icon :alt="$t('buttons.email-verification.verification-verified.close')">
              mdi-close
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons.email-verification.verification-verified.close') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import bus, { eventNames } from '@/lib/eventBus'
import HOPPERMATION_DEFAULT_SENDER from '@/modules/emailVerification/queries/HoppermationDefaultSender.gql'

import ACKNOWLEDGE_DEFAULT_SENDER_VERIFICATION from './queries/AcknowledgeDefaultSenderVerification.gql'

export default {
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    updateQuery(store, { data: { defaultSender } }) {
      const data = store.readQuery({
        query: HOPPERMATION_DEFAULT_SENDER,
        variables: { companyId: this.$auth.user.companyId },
      })
      data.defaultSender = defaultSender
      store.writeQuery({
        query: HOPPERMATION_DEFAULT_SENDER,
        data,
        variables: { companyId: this.$auth.user.companyId },
      })
    },
    async acknowledgeDefaultSender() {
      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: ACKNOWLEDGE_DEFAULT_SENDER_VERIFICATION,
          variables: { companyId: this.$auth.user.companyId },
          update: this.updateQuery,
        })
      } catch (err) {
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.email-verification.verification-verified.error'),
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
